// extracted by mini-css-extract-plugin
module.exports = {"userCard":"index_userCard_ovU9d","typed":"index_typed_1py5t","userName":"index_userName_mkHZW","post":"index_post_Pdfce","plusBtn":"index_plusBtn_qbEM6"};